/* eslint-disable */
import {lista, nao_autorizado, pegaDados, processar} from '../../services/GenericAPI'
import {Filtro} from "../../models/filtro/filtro";
import {Marca} from '../../models/marca'
import {BaseDescSCH, getBaseSCH} from "../../search/BaseSCH";

const url = '/marcas'

const state = {
  all: [],
  allList: [],
  marca: new Marca(),
  filtro: new Filtro()
}

const getters = {
  listaAllMarcas: (state) => {
    return state.allList
  },

  listaMarcas: (state) => {
    return state.all
  },
  pegaCor: (state) => {
    return state.marca
  },
  pegaFiltro: (state) => {
    return state.filtro
  }
}

const actions = {
  searchItem({commit}, search) {
    state.filtro.filters.search = [];
  state.filtro.filters.addSearch(['descr'], '%' + search + '%', 'ilike')
  },
  async getItem({commit}, {marcas_id, onSucesso,onErro}) {
    try {
      var filtro = getBaseSCH('marca_id', marcas_id, '=')
      const list = (await pegaDados(url+'/get', filtro)).data
      if (list.data[0] !== undefined) {
        commit('SET_MARCA', list.data[0])
        onSucesso()
      } else {
        onErro()
      }
    } catch (error) {
      onErro()
      console.log(error)
    }
  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', BaseDescSCH(perPage))
  },

  async setAllListMarcas({commit}) {
    const list = (await lista(url + '/all')).data
    commit('SET_ALL_LIST', list)
  },
  async setAllMarcas({commit},{onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url + '/get', state.filtro)).data
      commit('SET_MARCAS', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
      nao_autorizado(error)
    }
  },
  async processarCor({commit}, {acao,onSucesso,onErro}) {
    try {
      let res = await processar(url + (acao === 'gravar' ? '/commit' : ''), state.marcas, acao)

      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      onErro()
      console.log('error: ',error)
      this.dispatch('geral/setObjMsgError', error.response.data)
    }
  },
  setContaReceber({commit}, marca) {
    commit('SET_MARCA', marca)
  },
}

const mutations = {

  SET_ALL_LIST(state, filtro) {
    state.allList = filtro
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
  SET_MARCAS(state, marcas) {
    state.all = marcas
  },
  SET_MARCA(state, marca) {
    state.marca = marca
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
